import { useContext } from "react";
import http from "utils/http";
import { AuthorizedContext } from "layout/authorized/AuthorizedLayout";
import ClientCard from "./components/ClientCard";
import styles from "./HomePage.module.scss";

function HomePage() {
  const { clients } = useContext(AuthorizedContext);

  const handleClientClick = async (client: any) => {
    if (client?.id) {
      try {
        const response = await http.post({
          url: "/api/Key/Generate",
          data: {
            clientId: client.id,
          },
        });
        window.open(`${client.callBack}?ssokey=${response.data.ssoKey}`);
      } catch {}
    }
  };

  return (
    <div className={styles.clients}>
      <div className={styles.content}>
        {clients.map((client, clientIndex) => {
          return (
            <ClientCard
              key={clientIndex}
              data={client}
              onClick={() => {
                if (client.enabled) {
                  handleClientClick(client);
                }
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

export default HomePage;
